// Webinar-Hintergründe für R-NetWork GmbH (16:9, IT-Motive mit Logo)
// cat: "office" | "abstract" | "infra" | "medical"
// style: "light" (hell, 30 Motive) | "dark" (dunkel/elegant, 10 Motive)
export const WEBINAR_STYLES = [
  { key: "light", label: "Hell" },
  { key: "dark", label: "Dunkel" },
  { key: "doccirrus", label: "DocCirrus" },
];

export const WEBINAR_CATEGORIES = [
  { key: "all", label: "Alle" },
  { key: "office", label: "Büro" },
  { key: "infra", label: "Serverraum / Infrastruktur" },
  { key: "medical", label: "Praxis-IT" },
  { key: "abstract", label: "Abstrakt" },
];

// Heller Stil (30 Motive)
export const WEBINAR_BACKGROUNDS = [
  { file: "01-modern-office.jpg", title: "Modernes IT-Büro", desc: "Open-Space mit Workstations & Monitoren", cat: "office" },
  { file: "02-meeting-room.jpg", title: "IT-Besprechungsraum", desc: "Meetingraum mit Bildschirmwand", cat: "office" },
  { file: "03-server-room.jpg", title: "Serverraum", desc: "Rechenzentrum, hell & freundlich", cat: "infra" },
  { file: "04-reception-lobby.jpg", title: "IT-Helpdesk / Empfang", desc: "Support-Bereich mit Screen", cat: "office" },
  { file: "05-home-office.jpg", title: "IT-Home-Office", desc: "Dual-Monitor-Setup am Fenster", cat: "office" },
  { file: "06-abstract-tech.jpg", title: "Abstrakt / Netzwerk", desc: "Helles IT-/Netzwerk-Motiv", cat: "abstract" },
  { file: "07-medical-it.jpg", title: "Praxis-IT", desc: "IT-Arbeitsplatz im Praxisumfeld", cat: "medical" },
  { file: "08-coworking.jpg", title: "IT-Team / Co-Working", desc: "Entwickler-Arbeitsplätze", cat: "office" },
  { file: "09-conference-stage.jpg", title: "IT-Schulungsraum", desc: "Präsentationsraum mit Display", cat: "office" },
  { file: "10-city-dusk.jpg", title: "IT-Büro mit Skyline", desc: "Arbeitsplätze & Server vor Stadtpanorama", cat: "office" },
  { file: "11-open-loft-office.jpg", title: "Loft-IT-Büro", desc: "Modernes Open-Space im Loft-Stil", cat: "office" },
  { file: "12-glass-meeting.jpg", title: "Glas-Konferenzraum", desc: "Videokonferenz-Raum mit Glaswänden", cat: "office" },
  { file: "13-noc-monitoring.jpg", title: "Network Operations Center", desc: "Monitoring-Wand mit Dashboards", cat: "infra" },
  { file: "14-cloud-datacenter.jpg", title: "Cloud-Rechenzentrum", desc: "Heller Server-Gang, premium", cat: "infra" },
  { file: "15-helpdesk-support.jpg", title: "IT-Support / Helpdesk", desc: "Headset-Arbeitsplätze, freundlich", cat: "infra" },
  { file: "16-developer-desk.jpg", title: "Entwickler-Arbeitsplatz", desc: "Curved-Monitor am Fenster", cat: "office" },
  { file: "17-bright-lounge.jpg", title: "Tech-Lounge", desc: "Helle Lounge mit Wand-Display", cat: "office" },
  { file: "18-training-classroom.jpg", title: "IT-Schulungsraum", desc: "Schulung mit Präsentations-Display", cat: "office" },
  { file: "19-abstract-circuit.jpg", title: "Abstrakt / Platine", desc: "Helles Circuit-Board-Motiv", cat: "abstract" },
  { file: "20-abstract-data-flow.jpg", title: "Abstrakt / Datenfluss", desc: "Sanfte Partikel- & Netzwerk-Ströme", cat: "abstract" },
  { file: "21-medical-reception.jpg", title: "Praxis-Empfang", desc: "Heller Empfangsbereich mit Screen", cat: "medical" },
  { file: "22-clinic-workstation.jpg", title: "Klinik-IT-Arbeitsplatz", desc: "Computer & Netzwerk-Rack", cat: "medical" },
  { file: "23-rooftop-office.jpg", title: "Dachterrassen-Büro", desc: "Lichtes Büro mit Himmelblick", cat: "office" },
  { file: "24-library-tech.jpg", title: "Tech-Bibliothek", desc: "Ruhige helle Arbeitszone", cat: "office" },
  { file: "25-startup-hub.jpg", title: "Startup-Hub", desc: "Lebhaftes Co-Working mit Meeting-Pod", cat: "office" },
  { file: "26-server-rack-closeup.jpg", title: "Server-Rack Nahaufnahme", desc: "Sauberes Rack mit Status-LEDs", cat: "infra" },
  { file: "27-presentation-stage.jpg", title: "Präsentationsbühne", desc: "LED-Wand für Tech-Events", cat: "office" },
  { file: "28-coffee-corner.jpg", title: "Büro-Kaffeeecke", desc: "Helle Kitchenette mit Display", cat: "office" },
  { file: "29-dual-monitor-window.jpg", title: "Dual-Monitor am Fenster", desc: "Aufgeräumter Remote-Arbeitsplatz", cat: "office" },
  { file: "30-collaboration-wall.jpg", title: "Kollaborations-Wand", desc: "Interaktive Touchscreen-Wand", cat: "office" },
];

// Dunkler / eleganter Stil (10 Motive) — Dateien unter /assets/webinar/dark/
export const WEBINAR_BACKGROUNDS_DARK = [
  { file: "dark/01-modern-office.jpg", title: "Modernes Büro", desc: "Elegantes Navy-Büro mit Markenakzent", cat: "office" },
  { file: "dark/02-meeting-room.jpg", title: "Besprechungsraum", desc: "Dunkler Meetingraum mit Skyline", cat: "office" },
  { file: "dark/03-server-room.jpg", title: "Serverraum", desc: "Rechenzentrum mit blauem Licht", cat: "infra" },
  { file: "dark/04-reception-lobby.jpg", title: "Empfang / Lobby", desc: "Stilvoller Empfangsbereich", cat: "office" },
  { file: "dark/05-home-office.jpg", title: "Home-Office", desc: "Warmes Home-Office mit Rack", cat: "office" },
  { file: "dark/06-abstract-tech.jpg", title: "Abstrakt / Tech", desc: "Dunkles Tech-/Lounge-Motiv", cat: "abstract" },
  { file: "dark/07-medical-it.jpg", title: "Praxis-IT", desc: "IT-Arbeitsplätze, abendliche Stimmung", cat: "medical" },
  { file: "dark/08-coworking.jpg", title: "Co-Working", desc: "Gemütliche Lounge mit Tageslicht", cat: "office" },
  { file: "dark/09-conference-stage.jpg", title: "Bühne / Vortrag", desc: "Elegante Navy-Bühnenwand", cat: "office" },
  { file: "dark/10-city-dusk.jpg", title: "Skyline (Dämmerung)", desc: "Büro mit Stadtpanorama bei Nacht", cat: "office" },
];

// DocCirrus-Stil (30 Motive, helle Basis + DocCirrus-Branding) — Dateien unter /assets/webinar/doccirrus/
export const WEBINAR_BACKGROUNDS_DOCCIRRUS = WEBINAR_BACKGROUNDS.map((b) => ({
  ...b,
  file: `doccirrus/${b.file}`,
}));

export const WEBINAR_SETS = {
  light: WEBINAR_BACKGROUNDS,
  dark: WEBINAR_BACKGROUNDS_DARK,
  doccirrus: WEBINAR_BACKGROUNDS_DOCCIRRUS,
};
